<template>
  <div class="selected-items shadow-default">
    <div class="selected-header" :class="showing ? 'pb-2' : ''" @click="setShowing">
      {{ `${contents.length} ${contents.length === 1 ? 'item selecionado' : 'itens selecionados' }` }}
    </div>
    <div v-if="showing">
      <div class="selected-body">
        <ul class="pl-4 pt-2 font-size-small">
          <li v-for="(content, index) in contents" :key="index">
            {{ content.title || content.name }}
          </li>
        </ul>
      </div>
      <div class="selected-footer">
        <Button
          class="btn-outline-color2"
          :loading="loader"
          @click="submit"
        >
          Excluir
        </Button>
      </div>
    </div>
  </div>
</template>

<script>

import Button from '@/components/common/Button/Button'
import ListsService from '@/modules/lists/services/lists-service'
import NotificationService from '@/modules/notifications/services/notifications-service'

export default {
  components: {
    Button
  },
  props: ['contents', 'list'],
  data () {
    return {
      showing: false,
      loader: false
    }
  },
  methods: {
    setShowing () {
      this.showing = !this.showing
    },
    async submit () {
      this.errors = null
      this.loader = true
      try {
        const contents = this.contents.map(item => {
          return {
            id: item.id,
            type: item.type
          }
        })
        await ListsService.destroyMultipleContents(this.list.id, contents)
        this.$emit('items-destroyed', contents)
        const notification = {
          notification: {
            type: 'success',
            content: 'Publicações removidas com sucesso da lista'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>

<style lang="scss" scoped>
.selected-items {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
  z-index: 3;

  @include tablet {
    width: 300px;
    right: 15px;
    -webkit-border-top-left-radius: 20px;
    -webkit-border-top-right-radius: 20px;
    -moz-border-radius-topleft: 20px;
    -moz-border-radius-topright: 20px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;

    .selected-header {
      -webkit-border-top-left-radius: 20px;
      -webkit-border-top-right-radius: 20px;
      -moz-border-radius-topleft: 20px;
      -moz-border-radius-topright: 20px;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
    }
  }

  .selected-header {
    text-align: center;
    cursor: pointer;
    padding: 10px;
    background: #EA6C54;
    font-weight: bold;
    border-color: #EA6C54;
    color: #fff;
  }

  .selected-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 0;
  }

  .selected-body {
    padding: 10px;
    min-height: 200px;
    max-height: 300px;

    overflow-y: scroll;
    scrollbar-color: #EA6C54 #fff;
    scrollbar-width: thin;

    ul li {
      list-style: disc;
    }

    /* width */
    &::-webkit-scrollbar {
      width: 10px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #EA6C54;
      border: 2px solid #fff;
      -webkit-border-radius: 5px;
    }
  }
}
</style>
